import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";
import { sortCollection } from "../../../../common/utils";
import { SORT_TYPES } from "../../../../common/constants";

type EmployeeSelectProps = {
  handleEmployeeChange: any;
  selectedEmployee: any;
  employees: any;
  disabled: any;
  newUser: boolean;
  id: any;
  securityRoles: any;
  edit: boolean;
  setHiddenRole?: any;
  errors: any;
  disableClearable?: boolean;
};

const EmployeeSelect: FC<EmployeeSelectProps> = ({
  handleEmployeeChange,
  employees,
  selectedEmployee,
  disabled,
  newUser,
  id,
  edit,
  setHiddenRole = false,
  errors,
  disableClearable = false
}) => {
  const employeesSortedByName = sortCollection<any>(
    employees?.map((employee) => ({
      ...employee,
      label: `${employee.lastName}, ${employee.name}`,
    })),
    "label",
    SORT_TYPES.ASC,
    false
  );

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 56,
      minHeight: 56,
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "18.7rem",
    }),
  };

  const handleChange = (selectedOption: any) => {
    handleEmployeeChange(selectedOption, id);
  };

  const handleMenuOpen = () => {
    setHiddenRole(true);
  };

  const handleMenuClose = () => {
    setHiddenRole(false);
  };

  return (
    <Autocomplete
    id="idEmployee"
    options={employeesSortedByName || []}
    getOptionLabel={(option) => `${option.label}`}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    value={
      employeesSortedByName && selectedEmployee
        ? employeesSortedByName.find((employee) => employee.id === selectedEmployee) || null
        : null
    }
    onChange={(event, newValue) => handleChange(newValue)}
    disabled={disabled}
    disableClearable={disableClearable}
    onOpen={setHiddenRole ? handleMenuOpen : undefined}
    onClose={setHiddenRole ? handleMenuClose : undefined}
    loading={employeesSortedByName == null}
    renderInput={(params) => (
      <TextField
        {...params}
        fullWidth
        label={`${intl.get("employeeProjectForm.employee")}`}
        placeholder={intl.get("employeeProjectForm.placeholder.employee")}
        error={!!errors.employee}
        helperText={errors.employee}
        size="small"
      />
    )}
  />
  );
};

export default EmployeeSelect;
